import React from "react";
import Reveal from "./Reveal";
import { Header, Inputs, Machine } from "./StoryPanels";
import { ThermalFlow } from "./ThermalFlow";
import { AgroFlow } from "./AgroFlow";

const tid = name => `${name}-mobile`;

const Connector = ({ label, tone = "", testId }) => (
  <div className={`mobile-connector ${tone}`} data-testid={tid(testId)} aria-hidden="true">
    <svg viewBox="0 0 2 56" preserveAspectRatio="none">
      <path d="M1 0V56" fill="none" stroke={tone === "is-oil" ? "var(--oil)" : "var(--green-light)"} strokeWidth="1.5" className="flow-line" />
    </svg>
    {label && <span>{label}</span>}
  </div>
);

// Mobile: one continuous vertical flow under a single pyrolysis header. The machine appears once.
const MobileStory = () => (
  <div className="bg-2 mobile-story" data-testid="story-section">
    <section id="tecnologia" className="px-6 pt-20 border-t border-line" data-testid={tid("pyro-section")}>
      <Reveal><Header tid={tid} /></Reveal>
      <div className="process-grid"><Reveal><Inputs tid={tid} /></Reveal></div>
      <Connector label="Biomasa residual" testId="connector-inputs" />
      <Reveal><Machine tid={tid} /></Reveal>
      <Connector label="Calor · circuito de aceite térmico" tone="is-oil" testId="connector-oil" />
      <Reveal><ThermalFlow tid={tid} /></Reveal>
    </section>
    <Connector label="El biochar sale de la unidad" tone="is-bridge" testId="connector-biochar" />
    <section id="agro" className="px-6 pb-20 scroll-mt-24" data-testid={tid("agro-section")}>
      <Reveal><AgroFlow tid={tid} /></Reveal>
    </section>
  </div>
);

export default MobileStory;
